export default {
  data() {
    return {
      hoverOption: -1,
      activedescendant: '' // Using aria-activedescendant to Manage Focus
    };
  },

  computed: {
    optionsAllDisabled() {
      return this.options.filter(option => option.visible).every(option => option.computedDisabled);
    }
  },

  watch: {
    hoverIndex(val) {
      if (typeof val === 'number') {
        this.hoverOption = this.options[val] || {};
      }
      this.options.forEach(option => {
        option.hover = this.hoverOption === option;
      });
      this.activedescendant = this.hoverOption.optionId;
    }
  },

  methods: {
    navigateOptions(direction) {
      if (!this.visible) {
        this.visible = true;
        return;
      }
      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
      if (!this.optionsAllDisabled) {
        if (direction === 'next') {
          this.hoverIndex++;
          if (this.hoverIndex === this.options.length) {
            this.hoverIndex = 0;
          }
        } else if (direction === 'prev') {
          this.hoverIndex--;
          if (this.hoverIndex < 0) {
            this.hoverIndex = this.options.length - 1;
          }
        } else if (direction === 'home') {//
          this.hoverIndex = 0;
        } else if (direction === 'end') {
          this.hoverIndex = this.options.length - 1;
        }
        const option = this.options[this.hoverIndex];
        // this.activedescendant = option;
        if (option.computedDisabled === true ||
          option.groupDisabled === true ||
          !option.visible) {
          direction = direction === 'home' ? 'next' : direction === 'end' ? 'prev' : direction;
          this.navigateOptions(direction);
        }

        this.$nextTick(() => {
          this.scrollToOption(this.hoverOption);
        });
      }
    }
  }
};
